/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberResidenceOutputDto { 
    districtName?: string | null;
    regionName?: string | null;
    wardName?: string | null;
    houseNumber?: string | null;
    country?: string | null;
    zip?: string | null;
    addressLine3?: string | null;
    addressLine2?: string | null;
    addressLine1?: string | null;
}

